import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Game } from '../models/game';
import { ConfigService } from '../services/config.service';
import { FootballGameLog } from '../models/football-game-log';
import { FootballGameStatistic } from '../models/football-game-statistic';
import { FootballGameTeamStatistic } from '../models/football-game-team-statistic';
import { GameBaseApi } from './game-base-api';

@Injectable({providedIn: 'root'})
export class FootballGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<FootballGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/team_statistic/`).pipe(
      map(result => FootballGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<FootballGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/user_statistic/`).pipe(
      map(result => FootballGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<FootballGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/logs/`).pipe(
      map(result => FootballGameLog.toFront(result))
    ).toPromise();
  }

  async downloadProtocol(gameId: number, format: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/game_protocol/`, {
      params: new HttpParams().set('file_type', format),
      responseType: 'blob'
    }).toPromise();
  }

  async downloadApplication(gameId: number, format: 'pdf' | 'xlsx' | 'html', type: 'game_user' | 'tournament_user'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/game_application_file/`, {
      params: new HttpParams().set('file_type', format).set('application_type', type),
      responseType: 'blob'
    }).toPromise();
  }
}
